import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { toast } from '../components/Toast';

export default function Cont() {
  const [cont, setCont] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ parolaVeche:'', parola:'', parolaConfirm:'' });
  const [telegramChatId, setTelegramChatId] = useState('');
  const [savingTelegram, setSavingTelegram] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/api/auth/cont')
      .then(r => { setCont(r.data); setTelegramChatId(r.data.telegramChatId || ''); })
      .finally(() => setLoading(false));
  }, []);

  // Contul demo e partajat intre toti vizitatorii - parola lui nu se poate schimba (si backend-ul o refuza).
  const esteDemo = localStorage.getItem('username') === 'demo';

  const esteAdmin = cont && (cont.rol === 'Level_0' || String(cont.rol).toLowerCase() === 'admin');

  const salveazaTelegram = async () => {
    setSavingTelegram(true);
    try {
      await api.put('/api/auth/cont', { telegramChatId });
      toast('Chat ID Telegram salvat!');
    } catch(e) {
      toast('Eroare: ' + (e.response?.data?.error || e.message), 'error');
    } finally {
      setSavingTelegram(false);
    }
  };

  const handleSave = async () => {
    setError('');
    if (!form.parolaVeche) { setError('Introdu parola curentă'); return; }
    if (!form.parola) { setError('Introdu parola nouă'); return; }
    if (form.parola !== form.parolaConfirm) { setError('Parolele noi nu coincid'); return; }
    if (form.parola.length < 6) { setError('Parola nouă trebuie să aibă cel puțin 6 caractere'); return; }

    setSaving(true);
    try {
      await api.put('/api/auth/cont', {
        parolaVeche: form.parolaVeche,
        parola: form.parola
      });
      toast('Parolă actualizată cu succes!');
      setForm({ parolaVeche:'', parola:'', parolaConfirm:'' });
    } catch(e) {
      setError(e.response?.data?.error || 'Eroare la salvare');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{padding:20,textAlign:'center',color:'#888'}}>Se încarcă...</div>;

  return (
    <div style={{maxWidth:480,margin:'0 auto',padding:16}}>
      {cont && (
        <div className="card" style={{marginBottom:20}}>
          <div className="card-header">👤 Date cont</div>
          <div style={{padding:16}}>
            <div style={{display:'flex',gap:24,flexWrap:'wrap',fontSize:13}}>
              <div><b>Username:</b> {cont.username}</div>
              <div><b>Rol:</b> {cont.rol}</div>
            </div>
          </div>
        </div>
      )}

      {esteAdmin && (
        <div className="card" style={{marginBottom:20}}>
          <div className="card-header">📲 Raport săptămânal expirări (Telegram)</div>
          <div style={{padding:16}}>
            <p style={{fontSize:12.5,color:'#666',marginTop:0}}>
              Ca administrator al firmei, primești în fiecare luni dimineață un raport cu
              documentele și reviziile care expiră sau au expirat. Completează aici chat ID-ul
              tău de Telegram ca să-l primești și acolo (pe lângă email).
            </p>
            <div className="form-group">
              <label>Telegram chat ID</label>
              <input type="text" value={telegramChatId}
                onChange={e=>setTelegramChatId(e.target.value)}
                placeholder="ex. 123456789"/>
            </div>
            <button className="btn btn-primary" onClick={salveazaTelegram} disabled={savingTelegram}
              style={{width:'100%',marginTop:8}}>
              {savingTelegram ? 'Se salvează...' : '💾 Salvează chat ID'}
            </button>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-header">🔐 Schimbă parola</div>
        <div style={{padding:16}}>
          {error && (
            <div style={{background:'#fde8e8',color:'#c0392b',padding:'8px 12px',
              borderRadius:4,marginBottom:12,fontSize:13}}>
              {error}
            </div>
          )}
          <div className="form-group">
            <label>Parola curentă</label>
            <input type="password" value={form.parolaVeche}
              onChange={e=>setForm({...form,parolaVeche:e.target.value})}
              placeholder="Parola actuală"/>
          </div>
          <div className="form-group">
            <label>Parola nouă</label>
            <input type="password" value={form.parola}
              onChange={e=>setForm({...form,parola:e.target.value})}
              placeholder="Cel puțin 6 caractere"/>
          </div>
          <div className="form-group">
            <label>Confirmă parola nouă</label>
            <input type="password" value={form.parolaConfirm}
              onChange={e=>setForm({...form,parolaConfirm:e.target.value})}
              placeholder="Repetă parola nouă"/>
          </div>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving || esteDemo}
            title={esteDemo ? 'Indisponibil în contul demo' : undefined}
            style={{width:'100%',marginTop:8,...(esteDemo ? {opacity:0.5,cursor:'not-allowed'} : {})}}>
            {saving ? 'Se salvează...' : '💾 Salvează parola'}
          </button>
          {esteDemo && (
            <div style={{marginTop:8,fontSize:12,color:'#888',textAlign:'center'}}>
              Schimbarea parolei nu este disponibilă în contul demo.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
